import { createSlice } from '@reduxjs/toolkit';

import { ProfilesState } from '@customTypes/users/profiles.types';
import { Action } from 'store/index';

interface InitialState {
    profiles: ProfilesState;
    selectedAccountAndSubAccount: SelectedAccountAndSubAccount;
    isChangedAccount: boolean;
    redirectBlocker: boolean;
}

interface SelectedAccountAndSubAccount {
    accountNumber: string;
    subAccountNumber: string;
    description: string;
    isExpandedRef?: boolean;
    isMandatoryRef2?: boolean;
    itemRef?: boolean;
    irpItemRef?: boolean;
    selectedAccountIds: string;
}

const initialState: InitialState = {
    profiles: {
        chosenPermissions: [],
        haveNewAccount: false,
        haveNewPermission: false,
        permissionButtonDisabled: true
    },
    selectedAccountAndSubAccount: {
        accountNumber: '',
        subAccountNumber: '',
        description: '',
        isExpandedRef: false,
        isMandatoryRef2: false,
        itemRef: false,
        irpItemRef: false,
        selectedAccountIds: ''
    },
    isChangedAccount: false,
    redirectBlocker: false
};

export const adminPanelSlice = createSlice({
    name: 'adminPanel',
    initialState,
    reducers: {
        setChosenPermissions(state, action: Action<string[]>) {
            state.profiles.chosenPermissions = action.payload;
        },
        setRedirectBlocker(state, action: Action<boolean>) {
            state.redirectBlocker = action.payload;
        },
        resetChosenPermissions(state) {
            state.profiles.chosenPermissions = [];
        },
        setSelectedAccountAndSubAccount(
            state,
            action: Action<SelectedAccountAndSubAccount>
        ) {
            state.selectedAccountAndSubAccount = {
                ...state.selectedAccountAndSubAccount,
                ...action.payload
            };
        },
        resetSelectedAccountAndSubAccount(state) {
            state.selectedAccountAndSubAccount =
                initialState.selectedAccountAndSubAccount;
        },
        setIsChangedAccount(state, action: Action<boolean>) {
            state.isChangedAccount = action.payload;
        },
        setHaveNewPermission(state, action: Action<boolean>) {
            state.profiles.haveNewPermission = action.payload;
        },
        setHaveNewAccount(state, action: Action<boolean>) {
            state.profiles.haveNewAccount = action.payload;
        },
        setPermissionButtonDisabled(state, action: Action<boolean>) {
            state.profiles.permissionButtonDisabled = action.payload;
        }
    }
});

export const {
    setChosenPermissions,
    resetChosenPermissions,
    setSelectedAccountAndSubAccount,
    resetSelectedAccountAndSubAccount,
    setIsChangedAccount,
    setRedirectBlocker,
    setHaveNewPermission,
    setHaveNewAccount,
    setPermissionButtonDisabled
} = adminPanelSlice.actions;
